import { ChangeDetectionStrategy, Component, computed, input, OnInit, signal } from '@angular/core';
import { Store } from '@components/stores-locator/model';
import { ButtonComponent } from '@shared/components/button';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { formatNextOpen, getStoreStatus } from '@shared/utils';

@Component({
  selector: 'app-store-detail',
  imports: [TitleComponent, ButtonComponent],
  templateUrl: './store-detail.component.html',
  styleUrl: './store-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StoreDetailComponent implements OnInit {
  store = input.required<Store>();
  readonly urlAppointment = input.required<string | null>();
  title = signal<Title>(null!);
  googleMapsUrl = signal<string>(null!);

  readonly isOpeningSoon = computed(() => this.store().operationalStatus?.code === 'OPENING_SOON');

  readonly statusIndicator = computed<{ modifier: string; message: string } | null>(() => {
    const { operationalStatus, weeklyOpeningHours } = this.store();

    if (operationalStatus?.code === 'OPENING_SOON') return null;

    if (operationalStatus?.code === 'TEMPORARILY_CLOSED') {
      return { modifier: 'temporarily_closed', message: operationalStatus.message };
    }

    if (!weeklyOpeningHours) return null;

    const now = new Date();
    const status = getStoreStatus(weeklyOpeningHours, now);

    if (status.isOpenNow) {
      return {
        modifier: 'open',
        message: status.currentSlotEnd ? `Ouvert - Jusqu'à ${status.currentSlotEnd}` : 'Ouvert',
      };
    }

    if (!status.nextOpening) {
      return { modifier: 'closed', message: 'Fermé' };
    }

    const { dayOffset, dayIndexMonFirst, openTime } = status.nextOpening;
    return {
      modifier: 'closed',
      message: `Fermé - ${formatNextOpen(dayOffset, dayIndexMonFirst, openTime, now)}`,
    };
  });

  ngOnInit(): void {
    this.googleMapsUrl.set(`https://www.google.fr/maps/search/Perene - ${this.store().address}`);
    this.title.set({
      color: 'BLACK',
      text: this.store().name,
      weight: 600,
      font: 'INTER',
      level: 'SPAN',
      size: {
        desktop: 'H6',
        mobile: 'H5',
        custom: {
          mobile: '1.6rem',
          desktop: '2rem',
        },
      },
    });
  }
}
